import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubTopicRanking } from '../../models/SubTopicRanking.model';

@Component({
    selector: 'mh-ranking-table-widget',
    templateUrl: './ranking-table-widget.component.html',
    styleUrls: ['./ranking-table-widget.component.scss'],
    standalone: false
})
export class RankingTableWidgetComponent {
  @Input() rankingTableData: SubTopicRanking;
  @Input() rankingPolarity: string;
  @Output() getRankingTable = new EventEmitter<void>();
  @Input() loadingRankingTable: boolean;
}
